<ng-container *ngLet="showBannerOnly$ | async as showBannerOnly">
	<footer>
		<section class="container">
			<section class="row">
				<div
					class="col-12 col-md-4"
					[class.align-logo-center]="!showBannerOnly"
				>
					<a [routerLink]="getRouterLink(ROUTE_PATH.ROOT)">
						<app-logo></app-logo>
					</a>
					<p class="mt-2 text-brand" [class.text-center]="!showBannerOnly">
						&copy; {{ currentYear }} Seltron d.o.o.
					</p>
				</div>

				<ng-container *ngIf="showBannerOnly">
					<div class="col-12 col-md-4">
						<ul>
							<li>
								<a
									[routerLink]="getRouterLink(ROUTE_PATH.APPLICATION)"
									translate
									>Clausius App</a
								>
							</li>
							<li>
								<a
									[routerLink]="getRouterLink(ROUTE_PATH.HOW_IT_WORKS)"
									translate
									>How it works</a
								>
							</li>
							<li>
								<a [routerLink]="getRouterLink(ROUTE_PATH.OFFER)" translate
									>Offer</a
								>
							</li>
							<li>
								<a [routerLink]="getRouterLink(ROUTE_PATH.PARTNERS)" translate
									>Become a partner</a
								>
							</li>
							<li>
								<a [routerLink]="getRouterLink(ROUTE_PATH.CONTACT)" translate
									>Contact and support</a
								>
							</li>
							<li>
								<a
									href="https://betterstatus.seltronhome.com/"
									target="_blank"
									translate
									>Service status</a
								>
							</li>
						</ul>
					</div>

					<ng-container *ngLet="langChange | async">
						<div class="col-12 col-md-4 col-footer-info">
							<p translate>Web store</p>
							<a [externalRedirect]="EXTERNAL_PATH.SELTRON_PAGE"
								>www.seltron.si</a
							>
							<p translate>More information:</p>
							<a [externalRedirect]="EXTERNAL_PATH.SELTRON_EU_HOME_PAGE">
								<span translate>Web page</span> Seltron.eu</a
							>
							<a
								[routerLink]="getRouterLink(ROUTE_PATH.LEGAL)"
								[queryParams]="{ page: 'terms', lng: languageName }"
								translate
							>
								General terms and conditions for end users
							</a>
							<a
								[routerLink]="getRouterLink(ROUTE_PATH.LEGAL)"
								[queryParams]="{ page: 'terms_partners', lng: languageName }"
								translate
							>
								General conditions for business users
							</a>
							<a
								[routerLink]="getRouterLink(ROUTE_PATH.LEGAL)"
								[queryParams]="{ page: 'privacy', lng: languageName }"
								translate
							>
								Privacy policy
							</a>
						</div>
					</ng-container>
				</ng-container>
			</section>
		</section>
	</footer>
</ng-container>
